import { IconDefinition, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FilterKeyValue } from "appDtos";
import React from "react";
import Icon from "./Icon";

export const filterHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.6rem',
  }

const styles = {
  wrapper: (collapse: boolean, scrollHeight: number | undefined): React.CSSProperties => ({
    maxHeight: collapse ? 0 : scrollHeight,
    overflow: 'hidden',
    transition: 'max-height 0.4s ease',
  }),
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.4rem 0.6rem',
    marginBottom: '1px',
    border: '1px solid #ffc107', // warning border
  },
  filterSet: {
    maxHeight: '16rem',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  } as React.CSSProperties,
  filterItem: {
    margin: '1px 0',
    cursor: 'pointer',
  } as React.CSSProperties,
};


export interface FilterSetProps {
    icon: IconDefinition;
    title: string;
    keyValues: FilterKeyValue[];
    filterKey: string;
    value?: number | string;
    onChange: (value: any) => void
}

export function FilterSet(props: FilterSetProps) {
    const [collapse, setCollapse] = React.useState(false);
    const contentRef = React.useRef<HTMLDivElement>(null);
  
    return (
      <div style={{ marginBottom: '0.25rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={styles.header}>
          <div className="h6 mb-0"><Icon icon={props.icon} /> {props.title}</div>
          <button
            aria-label="filter-collapse-button"
            type="button"
            onClick={() => setCollapse(!collapse)}
            className="btn btn-link p-0 m-0"
            style={{ textDecoration: 'none' }}
          >
            <Icon color="black" icon={collapse ? faChevronDown : faChevronUp} />
          </button>
        </div>
        <div
          ref={contentRef}
          style={styles.wrapper(collapse, contentRef.current?.scrollHeight)}
        >
          <div style={styles.filterSet}>
            <ul className="list-group">
              {props.keyValues.map((s: any) => (
                <li
                  key={s.key}
                  title={s.value}
                  style={{
                    ...styles.filterItem,
                  }}
                  className="list-group-item text-truncate filter-set-hover"
                  onClick={() => props.onChange({ [props.filterKey]: s.key })}
                >
                  <input
                    className="form-check-input me-1"
                    type="checkbox"
                    value={s.key}
                    aria-label={s.value}
                    checked={props.value === s.key}
                    readOnly
                  />
                  {s.value}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }

export function DateFilterSet({ children, ...props }: any) {
  const [collapse, setCollapse] = React.useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  return (
    <div style={{ marginBottom: '0.25rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <div style={styles.header}>
        <div className="h6 mb-0"><Icon icon={props.icon} /> {props.title}</div>
        <button
          aria-label="filter-collapse-button"
          type="button"
          onClick={() => setCollapse(!collapse)}
          className="btn btn-link p-0 m-0"
          style={{ textDecoration: 'none' }}
        >
          <Icon color="black" icon={collapse ? faChevronDown : faChevronUp} />
        </button>
      </div>
      <div
        ref={contentRef}
        style={styles.wrapper(collapse, contentRef.current?.scrollHeight)}
      >
        <div style={styles.filterSet}>
          {children}
        </div>
      </div>
    </div>
  );
}
